// extracted by mini-css-extract-plugin
export default {"DotIcon":"dot-icon_DotIcon__9Zm-G"};